<template>
  <div>
    <div v-if="debug" class="bleed-point" v-for="bleedPoint in bleedPoints" :style="bleedPointStyle(bleedPoint)" style=""></div>
    <div class="bleed-point" v-for="outerPoint in outerPoints" :style="bleedPointStyle(outerPoint, true)" style="background-color:purple"></div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  export default{
    props:{
      bleedPoints:{
        type:Array,
        default:[]
      }
    },
    computed:{
      ...mapGetters(['flags']),
      debug() {
        return this.flags.debugTools;
      },
      outerPoints(){
        const outerArrays = this.bleedPoints.map(bleedPoint => bleedPoint.o);
        return [].concat(...outerArrays); // flatten array of arrays.
      }
    },
    methods:{
      bleedPointStyle(sample, isOuterSample){

        let display = this.debug ? 'block' : 'none';
        let backgroundColor = sample.isColored ? 'lime' : 'yellow';
        let border = 'none';

        if (isOuterSample){
          backgroundColor = 'purple';
          if (sample.badBleed){
            display = 'block';

            // colors to modify for production (all the other colors are just for debug.
            backgroundColor = 'magenta';
            border = '1px solid darkblue';
          }

        }
        return {
          left: sample.x + 'px',
          top: sample.y + 'px',
          backgroundColor,
          display,
          border
        }
      }
    }
  }
</script>

<style scoped>
  .bleed-point{
    position:absolute;
    width:4px;
    height:4px;
    transform:translate(-50%,-50%);
    pointer-events:none;
    z-index:1;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/editor/BleedPointDisplay.vue